import { Checkbox } from "antd";
import { useState } from "react";
import toast from "react-hot-toast";
import { BiSolidTrash } from "react-icons/bi";
import { useSelector } from "react-redux";
import { Card, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { uniqueID } from "../../firebase/utility";
import ImageUpload from "../imageUpload/ImageUpload";
import AddTrackingModal from "../modals/AddTrackingModal";
import StockTable from "../table/StockTable";
import NotesCard from "./NotesCard";

const PurchaseItemCard = ({
  data,
  setLineItems,
  line_items,
  index,
  stockData,
  distributorStockLoading,
  maxSoQuantity,
}) => {

  const [trackingModal, setTrackingModal] = useState(false);
  const toggleTrackingModal = () => setTrackingModal(!trackingModal);
  const { all_products } = useSelector((state) => state.products);
  let parts;
  if (data?.sku?.length > 4) {
    parts = data?.sku?.slice(4, data?.sku?.length);
  } else {
    parts = data?.sku;
  }
  const [formData, setFormData] = useState({
    parts: parts ?? "",
    price: data?.price ?? 0,
    vendorSku: data?.vendorSku ?? "",
    description: data?.description ?? "",
    quantity: data?.quantity ?? 0,
    // notes: data?.notes ?? "",
    exUnitPrice: data?.exUnitPrice ?? 0,
    image: { id: data?.image?.id ?? "", src: data?.image?.src ?? "" },
  });
  const handleChange = (key, value) => {
    const updatedData =
      key === "image"
        ? { ...formData, [key]: { src: value, id: uniqueID() } }
        : { ...formData, [key]: value };
    setFormData(updatedData);
    const updatedItems = line_items?.map((item, idx) =>
      idx === index
        ? { ...item, [key]: key === "image" ? updatedData[key] : value }
        : item
    );
    setLineItems(updatedItems);
  };

  const handleQuantityChange = (val) => {
    let parsedVal = isNaN(parseInt(val)) ? 0 : Math.max(0, parseInt(val));
    if (
      maxSoQuantity !== null &&
      maxSoQuantity !== undefined &&
      parsedVal > Number(maxSoQuantity)
    ) {
      toast.error(
        `Purchase order quantity cannot exceed the sale order quantity (${maxSoQuantity})`
      );
      parsedVal = Number(maxSoQuantity);
    }
    const updatedData = { ...formData, quantity: parsedVal };
    setFormData(updatedData);
    const updatedItems = line_items?.map((item, idx) =>
      idx === index
        ? { ...item, quantity: parsedVal }
        : item
    );
    setLineItems(updatedItems);
  };
  const deleteItem = (sku) => {
    const filteredItems = line_items?.filter((item) => item.sku !== sku);
    setLineItems(filteredItems);
  };
  const getStockQty = (parts) => {
    let result = all_products?.find((i) => {
      let part = i?.sku?.slice(4, i?.sku?.length);
      return part === parts;
    });
    return result?.stc_quantity;
  };
  const getStockData = (skuOrPart) => {
    if (!skuOrPart || !Array.isArray(stockData) || stockData.length === 0) return [];
    
    const normalize = (val) => {
      if (!val) return "";
      return val
        .toString()
        .trim()
        .replace(/^[a-zA-Z0-9]{2,4}[-_]/i, "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
    };

    const rawNormalize = (val) => {
      if (!val) return "";
      return val.toString().trim().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    };

    const targetNorm = rawNormalize(skuOrPart);
    const targetCore = normalize(skuOrPart);

    return stockData.filter((i) => {
      if (!i) return false;
      const candidates = [
        i?.sku,
        i?.partNumber,
        i?.itemId,
        i?.raw?.itemId,
        i?.raw?.sku,
        i?.raw?.partNumber,
        i?.raw?.vendorPartNumber,
        i?.raw?.detailedInfo?.vendorItemId,
        i?.raw?.ingramPartNumber
      ].filter(Boolean);

      return candidates.some((cand) => {
        const cNorm = rawNormalize(cand);
        const cCore = normalize(cand);
        if (targetNorm && cNorm && targetNorm === cNorm) return true;
        if (targetCore && cCore && targetCore === cCore) return true;
        if (targetCore && cNorm && (cNorm.includes(targetCore) || targetCore.includes(cNorm))) return true;
        if (targetNorm && cCore && (targetNorm.includes(cCore) || cCore.includes(targetNorm))) return true;
        return false;
      });
    });
  };
  return (
    <>
      <AddTrackingModal toggle={toggleTrackingModal} modal={trackingModal} />
      <Card className="border-0  shadow mb-3 py-3">
        <Row>
          <Col
            md={1}
            className="d-flex justify-content-center flex-column align-items-center"
          >
            <div>
              <ImageUpload
                index={index}
                itemImage={formData?.image?.src}
                handleImageUpload={handleChange}
              />
            </div>
            <div className="text-center">
              <BiSolidTrash
                style={{ color: "red" }}
                size={30}
                className="my-1"
                onClick={() => {
                  deleteItem(data?.sku);
                }}
              />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <Checkbox>
                <span className="fs-18">EPO</span>
              </Checkbox>
              <div>
                {getStockQty(parts) > 0 ? (
                  <p className="text-success fw-bold">
                    Stock({getStockQty(parts)})
                  </p>
                ) : (
                  <p className="text-danger fw-bold">Out of Stock</p>
                )}
              </div>
            </div>
          </Col>
          <Col md={2}>
            <FormGroup>
              <Label className="mb-1 fw-bold">Part #</Label>
              <Input
                type={"text"}
                placeholder={"Part"}
                value={formData.parts}
                className={"rounded-0"}
                onChange={(e) => handleChange("parts", e.target.value)}
                disabled
              />
            </FormGroup>
            <FormGroup>
              <Label className="mb-1 fw-bold">Vendor Sku</Label>
              <Input
                type={"text"}
                placeholder={"Vendor"}
                value={formData.vendorSku}
                className={"rounded-0"}
                onChange={(e) => handleChange("vendorSku", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={1}>
            <FormGroup>
              <div className="d-flex align-items-center justify-content-between mb-1">
                <Label className="mb-0 fw-bold">Quantity</Label>
                {maxSoQuantity !== null && maxSoQuantity !== undefined && (
                  <span
                    className="badge bg-light text-primary border px-1"
                    style={{ fontSize: "9px" }}
                    title={`Sales Order Quantity: ${maxSoQuantity}`}
                  >
                    SO:{maxSoQuantity}
                  </span>
                )}
              </div>
              <Input
                type={"number"}
                placeholder={"0"}
                min={0}
                max={maxSoQuantity ?? undefined}
                value={formData.quantity}
                className={"rounded-0"}
                onChange={(e) => handleQuantityChange(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="mb-1 fw-bold">Description</Label>
              <NotesCard
                height={"20px"}
                type={"textarea"}
                className={"bg-secondary-color border-1 rounded-0"}
                placeholder={"This is just description"}
                value={formData.description}
                handleChange={(e) =>
                  handleChange("description", e.target.value)
                }
              />
            </FormGroup>
          </Col>
          <Col md={1}>
            <FormGroup>
              <Label className="mb-1 fw-bold">Unit Price</Label>
              <Input
                type={"text"}
                placeholder={"Unit Price"}
                className={"rounded-0"}
                value={formData.price}
                onChange={(e) => handleChange("price", e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={1}>
            <FormGroup>
              <Label className="mb-1 fw-bold">Ext Price</Label>
              <Input
                type={"text"}
                placeholder={"Sku"}
                className={"rounded-0"}
                value={(formData?.price * formData?.quantity).toFixed(2)}
                onChange={(e) => handleChange("sku", e.target.value)}
              />
            </FormGroup>
          </Col>

          {distributorStockLoading ? (
            <Col md={10} className="mx-auto mt-2">
              <div className="d-flex align-items-center justify-content-center py-3 bg-secondary-color rounded border border-light">
                <span className="spinner-border spinner-border-sm text-primary me-2" role="status" aria-hidden="true"></span>
                <span className="small text-muted fw-medium">Loading live distributor stock...</span>
              </div>
            </Col>
          ) : getStockData(parts || data?.sku)?.length > 0 ? (
            <Col md={10} className="mx-auto">
              <StockTable data={getStockData(parts || data?.sku)} />
            </Col>
          ) : null}
        </Row>
      </Card>
    </>
  );
};
export default PurchaseItemCard;
